import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, catchError, from, map, mergeMap, of } from 'rxjs';
import {
  FileGate,
  GetPdfContentResponse,
  GetPresignedUrlRequest,
  SaveS3FileRequest,
} from '../../../../../backend/src/core/file/file.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';
import { FileUtils } from '../../shared/utils/file-utils';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private _pictureMimeTypes = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'];

  openaiRetrievalMimeTypes = ['.csv', '.docx', '.html', '.json', '.md', '.pdf', 'pptx', '.py', '.tex', '.txt'];

  constructor(
    private lambdaService: LambdaService,
    private messageService: NzMessageService
  ) {}

  private _resourceName = ResourceName.file;

  saveFileToS3$(fileName: string, fileData: File): Observable<{ url: string }> {
    return FileUtils.readAsString$(fileData).pipe(
      mergeMap((base64Content) => {
        const noHeadContent = base64Content.split(',')[1];

        const request: SaveS3FileRequest = {
          fileName,
          base64Content: noHeadContent,
        };
        return this.lambdaService.run$(this._resourceName, FileGate.actions.saveS3File, request);
      })
    );
  }

  getPdfContent$(fileName: string, fileData: File): Observable<GetPdfContentResponse> {
    return FileUtils.readAsString$(fileData).pipe(
      mergeMap((base64Content) => {
        const noHeadContent = base64Content.split(',')[1];

        const request: SaveS3FileRequest = {
          fileName,
          base64Content: noHeadContent,
        };
        return this.lambdaService.run$(this._resourceName, FileGate.actions.getPdfContent, request);
      })
    );
  }

  getPresignedUrlToUpload$(fileUrl: string) {
    const request: GetPresignedUrlRequest = {
      fileUrl,
    };

    return this.lambdaService.run$(this._resourceName, FileGate.actions.getPresignedUrlToUpload, request);
  }

  uploadBlobToS3$(fileUrl: string, blob: Blob) {
    return this.getPresignedUrlToUpload$(fileUrl).pipe(
      mergeMap((data) => {
        return this.uploadFile$(blob, data?.url!);
      })
    );
  }

  private uploadFile$(blob: Blob, url: string): Observable<void> {
    if (!url) {
      this.messageService.error('Failed to get presigned upload URL.');
      return of(undefined);
    }

    return from(
      fetch(url, {
        method: 'PUT',
        body: blob,
        headers: {
          'Content-Type': 'video/webm',
        },
      })
    ).pipe(
      map((response) => {
        if (response.ok) {
        } else {
          throw new Error('Failed to upload file: ' + response.statusText);
        }
      }),
      catchError((error) => {
        this.messageService.error(error.message);
        return of(undefined);
      })
    );
  }
}
